<template>
  <div
    class="border-blue-500 border-l-2 p-12 mt-16 gap-12 flex-row flex bg-grey-100"
  >
    <Icon
      iconClass="fas fa-exclamation-circle"
      class="text-xl text-blue-500 self-center"
    />
    <div class="grid grid-cols-6 gap-4 items-center pl-10">
      <p class="text-sm col-span-5">
        {{
          coalescedSupportText(
            'rewards.redemptions_unavailable_banner',
            'rewards.redemptions_unavailable_banner_alt'
          )
        }}
      </p>
    </div>
  </div>
</template>

<script>
import supportMixin from '../../mixins/support'
export default {
  mixins: [supportMixin],
}
</script>
